import React, { useState, useEffect } from 'react';
import { coreAPI } from '../../services/api';
import { useOrganization } from '../../context/OrganizationContext';
import './About.css';

const About = () => {
  const { organization } = useOrganization();
  const [aboutContent, setAboutContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAbout();
  }, []);

  const fetchAbout = async () => {
    try {
      const aboutRes = await coreAPI.getAbout();
      setAboutContent(aboutRes.data.content);
    } catch (error) {
      console.error('Failed to fetch about content:', error);
    } finally {
      setLoading(false);
    }
  };

  const councilor = {
    ...organization,
    about_content: aboutContent
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="about-page">
      <div className="container">
        <div className="about-header">
          <h1>關於{councilor?.chinese_name || councilor?.english_name || 'Hong Kong Synergies'}</h1>
        </div>
        <div className="about-content card">
          {councilor?.profile_photo && (
            <div className="profile-photo-container">
              <img 
                src={councilor.profile_photo} 
                alt={councilor.chinese_name}
                className="profile-photo"
              />
            </div>
          )}
          <div 
            className="content-text"
            dangerouslySetInnerHTML={{ __html: councilor?.about_content || '' }}
          />
        </div>
      </div>
    </div>
  );
};

export default About;
